import { axiosGetHandler, axiosPostHandler } from '../config';

export function getRoomList(args) {
  let url = '/store/roll_room_v2/room_list';
  return axiosGetHandler(url, args);
}

// 获取参与人
export function getTicketRank(args) {
  let url = '/store/roll_room_v2/ticket_rank';
  return axiosGetHandler(url, args);
}

// 获取主要信息
export function getHomeInfo(args) {
  let url = '/store/roll_room_v2/get_home_info';
  return axiosGetHandler(url, args);
}

// 获取快递信息
export function getExpressInfo(args) {
  let url = '/store/roll_room_v2/get_express';
  return axiosGetHandler(url, args);
}

// 获取分享信息
export function getSharedInfo(args) {
  let url = '/store/roll_room_v2/get_shared_info';
  return axiosGetHandler(url, args);
}

export function getDataReport(args, formdata) {
  let url = '/store/roll_room_v2/data_report';
  return axiosPostHandler(url, args, formdata);
}

export function getTicketList(args) {
  let url = '/store/roll_room_v2/ticket_list';
  return axiosGetHandler(url, args);
}

// 关注
export function upOwner(args, formdata) {
  let url = '/bbs/app/profile/follow/user/web';
  return axiosPostHandler(url, args, formdata);
}

// join
export function join(args, formdata) {
  let url = '/store/roll_room_v2/join';
  return axiosPostHandler(url, args, formdata);
}

export function useBlankTicket(args, formdata) {
  let url = '/store/roll_room_v2/use_blank_ticket';
  return axiosPostHandler(url, args, formdata);
}

export function helpFriend(args, formdata) {
  let url = '/store/roll_room_v2/help_friend';
  return axiosPostHandler(url, args, formdata);
}

export function getJoinedList(args) {
  let url = '/store/roll_room_v2/joined_list';
  return axiosGetHandler(url, args);
}

export function getRecommendList(args) {
  let url = '/store/roll_room_v2/recommend_list';
  return axiosGetHandler(url, args);
}

export function getAddressList(args) {
  let url = '/mall/physical/user/address/web';
  return axiosGetHandler(url, args);
}

export function confirmAddress(args, formdata) {
  let url = '/store/roll_room_v2/address/set_for_award';
  return axiosPostHandler(url, args, formdata);
}

// 获取所有获奖人页面基本信息
export function getGachaResultBaseInfo(args) {
  let url = '/store/roll_room_v2/base_info';
  return axiosGetHandler(url, args);
}

// 获取所有获奖人页面或将列表
export function getGachaResultWinnerList(args) {
  let url = '/store/roll_room_v2/winner_list';
  return axiosGetHandler(url, args);
}
